export default __webpack_public_path__ + "static/media/nav-logo.24097749.png";